import * as React from 'react';
import Tooltip from 'components/ui/Tooltip/Tooltip';
import {Tags} from 'lucide-react';
import clsx from 'clsx';

export default function ListItemTags({tags = []}) {
	if (!Array.isArray(tags)) {
		return null;
	}

	const tagsCount = tags.length;

	const tooltipTrigger = (
		<div
			className={clsx(
				'flex items-center gap-x-1 rounded px-1.5 py-0.5',
				tagsCount ? 'text-gray-600' : 'text-gray-300',
			)}
		>
			<Tags className="size-4" /> <span className="font-medium">{tagsCount}</span>
		</div>
	);

	return (
		<div
			className="flex flex-wrap items-center gap-2 h-full"
			onClick={e => e.stopPropagation()}
		>
			{tagsCount > 0 ? (
				<Tooltip placement="top" size="sm" trigger={tooltipTrigger}>
					<div className="flex flex-col gap-y-1 text-xs">
						{tags.map(tag => (
							<div key={tag.id} className="flex items-center gap-x-2">
								<div
									className="rounded-full size-2.5"
									style={{
										backgroundColor: tag.mapColor ?? '#000',
									}}
								></div>
								{tag.name}
							</div>
						))}
					</div>
				</Tooltip>
			) : (
				tooltipTrigger
			)}
		</div>
	);
}
